import React from 'react'

export default function Contact() {
  return (
    <main className='contact-container'>
      <section className='contact-wrapper'>
        <h2>Kontakta oss</h2>

        <p> Har du frågor, funderingar eller vill komma i kontakt med oss? Vi finns här för att hjälpa dig! </p>

        <article className='contact'>
        <p>E-post: sound1@example.com</p>
        <p>Telefon: +46 123 456 789</p>
        </article>
      </section>
    </main>
  )
}
